module.exports = __webpack_public_path__ + "static/cal-ripkin@2x-588b80ea9092074dd04184282385d1ef.png";